import { Injectable, WritableSignal, signal } from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class URLService {
  public previousUrl: WritableSignal<string | null> = signal(null)
  public currentUrl: WritableSignal<string | null> = signal(null)
  constructor() {}
}
